import { api } from './client.js';
import { WEB_API_PREFIX } from '../config.js';

/*
 * Web auth — email one-time code, then a 30-day JWT.
 * These endpoints are live in production.
 *
 *   POST /api/web/auth/request  {email}
 *   POST /api/web/auth/verify   {email, code} -> {token, user}
 *   GET  /api/web/auth/me
 *   POST /api/web/auth/logout
 */

/**
 * Ask for a sign-in code.
 *
 * The backend deliberately returns the same generic success for unknown
 * addresses and for rate-limited requests, so the UI must not promise that an
 * email was definitely sent — only that one will arrive if the address is valid.
 */
export function requestCode(email) {
  return api.post(`${WEB_API_PREFIX}/auth/request`, { body: { email } });
}

/**
 * Exchange the 6-digit code for a session token.
 *
 * Note: a wrong code comes back as HTTP 200 with {ok: false}, not an error
 * status, so callers must check `ok` rather than relying on a thrown error.
 */
export function verifyCode(email, code) {
  return api.post(`${WEB_API_PREFIX}/auth/verify`, { body: { email, code } });
}

/** The signed-in account. Throws 401 if the token has expired. */
export function getMe() {
  return api.get(`${WEB_API_PREFIX}/auth/me`, { auth: true });
}

/** Stateless on the server; the client still discards its token afterwards. */
export function logout() {
  return api.post(`${WEB_API_PREFIX}/auth/logout`, { auth: true });
}
